import React from "react"

export function Donate({donate}) {

    return (

        <div className="row justify-content-center mt-5">
            <div className="card" style={{width:"18rem"}}>
                <img className="card-img-top" src={require('../img/donate-banner-bigben.png')} alt="Card image cap" />
                <div className="card-body">
                    <h5 className="card-title">Hello 我是大班哥</h5>
                    <p className="card-text">如果覺得我寫的文章不錯，歡迎支持我 0.01 ETH，讓我更有動力寫下去！</p>
                    
                    <button type="button" className="btn btn-dark" onClick={donate}>
                        贊助 0.01 ETH 給大班哥
                    </button> 

                </div>
            </div>
        </div>        
    )
}
